import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
// @ts-expect-error untyped dependency
import localeComparator from 'I18n/utils/localeComparator';
import { useMemo } from 'react';
import FilterToggleGroup from './filterToggleGroup/FilterToggleGroup';
import { jsx as _jsx } from "react/jsx-runtime";
export function LanguageFilter({
  languages,
  name = 'language',
  onChange,
  searchable,
  value
}) {
  const options = useMemo(() => {
    return languages.reduce((final, lang) => {
      if (isValidI18nKey(`SharedI18nStrings.languageNames.${lang}`)) {
        final.push({
          text: I18n.text(`SharedI18nStrings.languageNames.${lang}`),
          value: lang
        });
      }
      return final;
    }, []).sort((optionA, optionB) => {
      return localeComparator(optionA.text, optionB.text);
    });
  }, [languages]);
  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    multi: true,
    name: name,
    onChange: event => onChange(event.target.value),
    options: options,
    searchable: searchable,
    value: value
  });
}